var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_56_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3.1705V3.1665H26.664C27.4 3.1665 28 3.77317 28 4.48917V28.5105C27.9997 28.8614 27.86 29.1978 27.6118 29.4459C27.3635 29.6939 27.0269 29.8332 26.676 29.8332H5.32403C5.14894 29.8319 4.97579 29.7962 4.81449 29.7281C4.65319 29.66 4.50689 29.5607 4.38395 29.4361C4.261 29.3114 4.16382 29.1637 4.09795 29.0015C4.03207 28.8392 3.9988 28.6656 4.00003 28.4905V11.1665L12 3.1705ZM7.77337 11.1665H12V6.93984L7.77337 11.1665ZM14.6667 5.83317V12.4998C14.6667 12.8535 14.5262 13.1926 14.2762 13.4426C14.0261 13.6927 13.687 13.8332 13.3334 13.8332H6.6667V27.1665H25.3334V5.83317H14.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEmpty);
export default __webpack_public_path__ + "static/media/FileEmpty.3112d5045b3e1064b5326ae9386aa453.svg";
export { ForwardRef as ReactComponent };